import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import LocalStorage from 'utils/helpers/localStorage';

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        LocalStorage.isLoggedIn() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              search: window.location.search,
              state: { referrer: window.location.pathname },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
